import { Extension } from '@tiptap/core';
import { scrollIntoViewByPosition } from '../../../scrolling';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    scrollIntoViewWithOffset: {
      /**
       * Scroll the current selection into view, accounting for sticky menu height
       */
      scrollIntoViewWithOffset: () => ReturnType;
    };
  }
}

const ScrollIntoViewWithOffset = Extension.create({
  name: 'scrollIntoViewWithOffset',
  addCommands() {
    return {
      scrollIntoViewWithOffset:
        () =>
        ({ view }) => {
          setTimeout(() => {
            const coords = view.coordsAtPos(view.state.selection.from);
            scrollIntoViewByPosition(coords.top);
          }, 10);
          return true;
        },
    };
  },

  addProseMirrorPlugins() {
    return [];
  },
});
export default ScrollIntoViewWithOffset;
